/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StaticPageAdmin } from './StaticPageAdmin'
import {
  StaticPageAdminFromJSON,
  StaticPageAdminFromJSONTyped,
  StaticPageAdminToJSON,
} from './StaticPageAdmin'

/**
 *
 * @export
 * @interface PaginatedStaticPageAdmin
 */
export interface PaginatedStaticPageAdmin {
  /**
   *
   * @type {Array<StaticPageAdmin>}
   * @memberof PaginatedStaticPageAdmin
   */
  results: Array<StaticPageAdmin>
  /**
   *
   * @type {number}
   * @memberof PaginatedStaticPageAdmin
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedStaticPageAdmin
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedStaticPageAdmin
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedStaticPageAdmin interface.
 */
export function instanceOfPaginatedStaticPageAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedStaticPageAdminFromJSON(json: any): PaginatedStaticPageAdmin {
  return PaginatedStaticPageAdminFromJSONTyped(json, false)
}

export function PaginatedStaticPageAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedStaticPageAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(StaticPageAdminFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedStaticPageAdminToJSON(value?: PaginatedStaticPageAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(StaticPageAdminToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
